
<template>
  <div id="About" @contextmenu.prevent>
	<div style="position: relative; justify-content: center;">
	<img src='/image/about.png' style="width:100%">
	</div>
  </div>
</template>
 
<script>
export default {
  name: 'About'
};
</script>